import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import AgorasPrice from "./agorasPrice";
import AgorasDistribution from "./agorasDistribution";
import AgorasVolume from "./agorasVolume";
import "./style.css";

class Market extends Component {
  state = {};
  render() {
    return (
      <section id="home-market">
        <div className="row container-size">
          <div className="col">
            <div className="home-market-content text-center">
              <span>
                <img
                  className="img-fluid"
                  src={require("../../../assets/icons/market-icon.png")}
                />{" "}
                Knowledge & Data
              </span>
              <h1
                className="text-center pt-2"
                style={{
                  color: "var(--h1Color)",
                  transition: "color 0.2s ease-out, background 0.2s ease-out"
                }}
              >
                Market
              </h1>

              <div className="text-center my-4 pt-1">
                <button
                  className="btn btn-primary explore-cta-btn "
                  type="button"
                  style={{
                    background: "var(--btnColor)",
                    transition: "color 0.2s ease-out, background 0.2s ease-out"
                  }}
                >
                  Explore
                  <img
                    className="img-fluid ml-2"
                    src={require("../../../assets/icons/arrow-icon.svg")}
                    alt="Arrow"
                  />
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="row mt-2 container-size">
          <AgorasPrice />
          <AgorasDistribution />
          <AgorasVolume />
        </div>
      </section>
    );
  }
}

export default Market;
